import { Link } from "react-router-dom";
import type { Work } from "@/types";

interface WorkCardProps {
  work: Work;
  size?: "default" | "compact";
}

export default function WorkCard({ work, size = "default" }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-200" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={work.cover}
          alt={`${work.title} 海报`}
          title={`${work.title} - 91看片高清影视`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs font-semibold text-accent-300 backdrop-blur-sm">
          <i className="ri-star-fill text-[11px]"></i>
          {work.rating.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-primary-600/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {work.type === "movie" ? "电影" : "剧集"}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-foreground-950/90 to-transparent p-3 transition-transform duration-300 group-hover:translate-y-0">
          <span className="flex items-center justify-center gap-1 rounded-md bg-accent-500 py-1.5 text-xs font-semibold text-primary-950">
            <i className="ri-play-fill"></i>
            查看详情
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
          {work.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{work.year}</span>
          <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
          <span className="truncate">{work.region}</span>
        </p>
        {size === "default" && (
          <div className="mt-2 flex flex-wrap gap-1">
            {work.genres.slice(0, 2).map((genre) => (
              <span
                key={genre}
                className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900"
              >
                {genre}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}